// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_LATEST_BADGE = {
  title: 'You earned Dish Wizard on Tuesday! ✦',
  story: 'Ten dish quests, zero broken plates. The whole village heard the sparkle.',
  icon: `${ASSET}/icon-dishes.png`,
  image: `${ASSET}/payday-festival.jpg`,
};

export const FIXTURE_BADGES = [
  { id: 'first-lantern', name: 'First Lantern', story: 'You lit your very first quest. Every story starts with one light.', status: 'earned', icon: `${ASSET}/lantern-mark.png`, dateLabel: 'May 2' },
  { id: 'week-of-light', name: 'Week of Light', story: 'Seven evenings glowing in a single chapter. The village stayed bright all week.', status: 'earned', icon: `${ASSET}/spot-trophy.png`, dateLabel: 'May 23' },
  { id: 'dish-wizard', name: 'Dish Wizard', story: 'Ten dish quests done — the kitchen lantern knows your name now.', status: 'earned', icon: `${ASSET}/icon-dishes.png`, dateLabel: 'Tuesday' },
  { id: 'dogs-best-friend', name: "Dog's Best Friend", story: "Fifteen walks with Biscuit. He'd give you this badge himself if he could.", status: 'earned', icon: `${ASSET}/icon-dog.png`, dateLabel: 'May 30' },
  { id: 'streak-of-three', name: 'Streak of Three', story: 'Three evenings glowing in a row — your flame is getting stronger.', status: 'earned', icon: `${ASSET}/icon-bed.png`, dateLabel: 'tonight!', tone: 'ember' },
  { id: 'early-bird', name: 'Early Bird', story: 'Light five quests before lunchtime. Still waiting for its light.', status: 'locked', icon: `${ASSET}/icon-plant.png` },
  { id: 'family-festival', name: 'Family Festival', story: 'Join a Payday where every Silva lit a lantern. Still waiting for its light.', status: 'locked', icon: `${ASSET}/icon-homework.png` },
  { id: 'saver-of-coins', name: 'Saver of Coins', story: 'Fill your Save jar to $20. Still waiting for its light — $13 to go.', status: 'locked', icon: `${ASSET}/spot-jars.png` },
];

export const FIXTURE_GOALS = [
  {
    id: 'lego',
    title: 'Save $20 for the LEGO set',
    value: 13,
    target: 20,
    percent: 65,
    format: 'currency',
    tone: 'gold',
    chips: [{ label: 'about 3 more weeks' }],
    note: 'Your Save jar feeds this candle every Friday Payday.',
  },
  {
    id: 'read',
    title: 'Read 10 evenings',
    value: 4,
    target: 10,
    percent: 40,
    format: 'count',
    unitLabel: 'evenings',
    // The candle always glows gold regardless of tone (GoalCandle fixes the reward colour); `tone`
    // only colours the "N%" chip. Gold keeps that chip at AA contrast on the dark jewel surface
    // (the `violet` chip class fails WCAG AA — 3.94:1 — so it is deliberately not used here).
    tone: 'gold',
    chips: [{ label: 'read last night ✓', tone: 'moss' }],
    note: 'One chapter a night and this candle keeps climbing.',
  },
];

export const FIXTURE_STREAK_HISTORY = {
  streakCount: 3,
  freezes: 1,
  weeks: [
    { label: 'May 18', summary: 'Week of May 18: five evenings lit', days: ['lit', 'lit', 'quiet', 'lit', 'lit', 'lit', 'quiet'] },
    { label: 'May 25', summary: 'Week of May 25: six evenings lit', days: ['lit', 'lit', 'lit', 'lit', 'lit', 'quiet', 'lit'] },
    { label: 'Jun 1', summary: 'Week of June 1: a streak freeze kept your flame safe on Wednesday', days: ['lit', 'lit', 'freeze', 'lit', 'lit', 'lit', 'quiet'] },
    { label: 'Jun 8', summary: 'Week of June 8: current streak of three', days: ['quiet', 'ember', 'ember', 'ember', 'future', 'future', 'future'] },
  ],
  note: "On June 3 your freeze stepped in while you were at Grandma's. Quiet evenings are part of every good story.",
};

export const trophiesFixture = {
  latestBadge: FIXTURE_LATEST_BADGE,
  badges: FIXTURE_BADGES,
  goals: FIXTURE_GOALS,
  streakHistory: FIXTURE_STREAK_HISTORY,
  kidName: 'Maya',
  streak: 3,
  avatar: `${ASSET}/avatar-kid-1.jpg`,
};
